import { useRef, useCallback } from 'react';
import { throttle } from 'throttle-debounce';

import { useSendWebAnalytics } from '@/shared/hooks/useSendWebAnalytics';

const VIDEO_STREAM_2MIN_TRESHHOLD_SEC = 120;
const VIDEO_STREAM_2MIN_THROTTLE_TIME_MS = 1000;

export function useOnWatchedTimeChanged() {
    const is2MinVideoEventSended = useRef(false);
    const sendWebAnalytics = useSendWebAnalytics();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(
        throttle(VIDEO_STREAM_2MIN_THROTTLE_TIME_MS, (watchedTime: number) => {
            if (watchedTime >= VIDEO_STREAM_2MIN_TRESHHOLD_SEC && !is2MinVideoEventSended.current) {
                sendWebAnalytics('VIDEO_STREAM_2MIN');
                is2MinVideoEventSended.current = true;
            }
        }),
        []
    );
}
